import type { ICefrLevelContent } from './types';

export const cefrLevelOrder = ['a1', 'a2', 'b1', 'b2', 'c1', 'c2'] as const;

const loadCefrEn = (): Promise<Record<string, ICefrLevelContent>> =>
  import('./en').then((m) => m.cefrContentEn);

const cefrContentLoaders: Record<string, () => Promise<Record<string, ICefrLevelContent>>> = {
  ar: () => import('./ar').then((m) => m.cefrContentAr),
  bn: () => import('./bn').then((m) => m.cefrContentBn),
  de: () => import('./de').then((m) => m.cefrContentDe),
  en: loadCefrEn,
  es: () => import('./es').then((m) => m.cefrContentEs),
  fa: () => import('./fa').then((m) => m.cefrContentFa),
  fr: () => import('./fr').then((m) => m.cefrContentFr),
  hi: () => import('./hi').then((m) => m.cefrContentHi),
  it: () => import('./it').then((m) => m.cefrContentIt),
  pt: () => import('./pt').then((m) => m.cefrContentPt),
  ru: () => import('./ru').then((m) => m.cefrContentRu),
  ur: () => import('./ur').then((m) => m.cefrContentUr),
  zh: () => import('./zh').then((m) => m.cefrContentZh),
};

export function getCefrContent(locale: string): Promise<Record<string, ICefrLevelContent>> {
  return (cefrContentLoaders[locale] ?? loadCefrEn)();
}

export type { ICefrLevelContent } from './types';
